export default "__VITE_ASSET__9WeDUpYn__"